import React from "react";
import { useNavigate } from "react-router-dom";

// material import
import { Grid2, Box, Button, Typography, Avatar } from "@mui/material";

// project import
import Logo from "../assets/suwa-arana-logo-white.png";

const DashboardHeader = ({ name, handleClick, open }) => {
  const navigate = useNavigate();

  //   const handleLogin = () => {
  //     navigate("/login");
  //   };

  return (
    <Box>
      <Grid2 item size={{ xs: 12 }} sx={{ height: 44 }} />
      <Grid2 container justifyContent="center">
        <Grid2
          item
          size={{ xs: 8.2 }}
          sx={{ mt: 4, display: "flex", justifyContent: "space-between" }}
        >
          <Box
            sx={{
              bgcolor: "#8B2757",
              width: 125,
              height: 120,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingX: 0.7,
            }}
          >
            <img
              src={Logo}
              alt="Suwa Arana Logo"
              style={{ maxWidth: "100%", height: "84%" }}
            />
          </Box>
          <Grid2
            container
            spacing={1}
            alignItems="center"
            justifyContent="right"
          >
            <Grid2 item size={{ xs: 10 }}>
              <Typography variant="h5" sx={{ fontSize: 18 }}>
                {" "}
                {name}
              </Typography>
            </Grid2>
            <Grid2 item size={{ xs: 0.5}}>
              <Avatar
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                sx={{ cursor: "pointer" }}
              >
              </Avatar>
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default DashboardHeader;
